module.exports = __webpack_public_path__ + "static/thumb-4-7247dcedb31a2915b31097a95533a588.jpg";